import Lottie from "lottie-react";
import peppaLoader from "../../assets/animations/peppa_loader.json";

export default function PeppaLoader() {
    return (
        <div className="loading">
            <Lottie
                animationData={peppaLoader}
                loop={true}
                autoplay={true}
                style={{ height: 25, width: 25 }}
            />
            {/* <p>Chargement...</p> */}
        </div>
    );
}